import { formatAddress } from '@govinity/shared-config';
import { cn } from '../../lib/utils.js';
export var LocationDisplay = function (_a) {
    var className = _a.className, fallback = _a.fallback, inline = _a.inline, location = _a.location, truncate = _a.truncate;
    var truncateClass = truncate ? 'min-w-0 truncate' : undefined;
    if (!location || !location.address) {
        return (<div className={cn(inline && 'inline-block', truncateClass, className)}>
        {fallback || 'N/A'}
      </div>);
    }
    if (inline) {
        return (<div className={cn('inline-block', truncateClass, className)}>
        {location.name} - {formatAddress(location.address)}
      </div>);
    }
    return (<div className={cn(className, truncate && 'min-w-0')}>
      <div className={cn(truncateClass)}>{location.name}</div>
      <div className={cn('text-muted-foreground text-sm', truncateClass)}>
        {formatAddress(location.address)}
      </div>
    </div>);
};
